import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

export default class EventModelsAdapter extends JSONAPIAdapter
{
	@service() config;
	@service errorManager;

	@computed('config')
	get host()
	{
		return this.config.get('eventBackendProtocol')+"://"+this.config.get('eventBackendHost')+":"+this.config.get('eventBackendPort');
	}

	@computed('config')
	get namespace()
	{
		return this.config.get('eventBackendNamespace');
	}

	coalesceFindRequests = true;

	handleResponse(status, headers, payload, requestData) {
		if (!this.isSuccess(status, headers, payload)) {
			// Extract error message from JSON:API error format
			const errorMessage = payload?.errors?.[0]?.detail
				|| payload?.errors?.[0]?.title
				|| payload?.error
				|| `Server error: ${status}`;
			this.errorManager.addError(errorMessage, { clearable: true, type: 'ember-data' });
		}
		return super.handleResponse(status, headers, payload, requestData);
	}

	ajax(url, type, options) {
		return super.ajax(url, type, options).catch((error) => {
			// Check if this is a network error (no response from server)
			if (error.name === 'TypeError' || error.message?.includes('Network') || error.status === 0) {
				this.errorManager.addError('Network error: Unable to connect to server', { clearable: true, type: 'network' });
			}
			throw error;
		});
	}
}

